import { Grid } from '@mui/material';

import { useClientSupervisionEditable } from '../../../../hooks';
import { FHSelect } from '../../../base';

import type { IClientSupervision, SelectValueType } from '../../../../utils/types';

interface CurrentClinicalStatusProps {
  clientSupervision: IClientSupervision | null;
  onUpdate: (data: IClientSupervision) => void;
}

function CurrentClinicalStatus(props: CurrentClinicalStatusProps) {
  const { clientSupervision, onUpdate } = props;
  const isEditable = useClientSupervisionEditable();

  return (
    <>
      <Grid container>
        <Grid item md={12}>
          <FHSelect
            data-testid="CurrentClinicalStatusDropDown"
            sx={{ minWidth: '150px', boxShadow: 'none' }}
            fullWidth
            inputHeight={40}
            disabled={!isEditable}
            options={[
              {
                value: 'No medical or safety concerns were noted during session',
                label: 'No medical or safety concerns were noted during session',
              },
              {
                value: 'Medical or safety concerns were noted during session',
                label: 'Medical or safety concerns were noted during session',
              },
            ]}
            value={clientSupervision?.clinical_status || ''}
            onUpdate={(value: SelectValueType) => {
              if (
                !clientSupervision ||
                (value !== 'No medical or safety concerns were noted during session' &&
                  value !== 'Medical or safety concerns were noted during session')
              )
                return;
              onUpdate({ ...clientSupervision, clinical_status: value });
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default CurrentClinicalStatus;
